import { capitalizeFirstLetter } from 'shared/utils/capitalizeFirstLetter'

export const configKeysMap = ['spotify', 'applemusic', 'itunes', 'shazam', 'airplay']

export const configMap = {
  airplay: {
    icon: 'icon fal fa-tower-broadcast',
    name: 'Airplay'
  },
  itunes: {
    icon: 'icon fa-brands fa-apple',
    name: 'iTunes'
  },
  applemusic: {
    icon: 'icon icon--apple-music',
    name: 'Apple Music'
  },
  gfk: {
    icon: 'icon fal fa-globe',
    name: 'GfK'
  },
  shazam: {
    icon: 'icon icon--shazam',
    name: 'Shazam'
  },
  spotify: {
    icon: 'icon fa-brands fa-spotify',
    name: 'Spotify'
  },
  aria: {
    icon: 'icon fal fa-globe',
    name: 'Aria'
  },
  recorded_music: {
    icon: 'icon fal fa-globe',
    name: 'Recorded Music'
  }
}

export const getChartAttr = (chart: string) => {
  const index = chart.lastIndexOf('_')
  const chartKey = index > -1 ? `${chart.slice(0, index)}` : chart
  const configArr = (configMap as any)[chartKey]

  return (
    configArr || {
      icon: 'icon fal fa-globe',
      name: capitalizeFirstLetter(chartKey)
    }
  )
}
